__turbopack_context__.v({
  "colorNeutral": "oZx6wG_colorNeutral",
  "colorSelected": "oZx6wG_colorSelected",
  "disabled": "oZx6wG_disabled",
  "sizeM": "oZx6wG_sizeM",
  "sizeS": "oZx6wG_sizeS",
  "toggleButton": "oZx6wG_toggleButton",
  "typography": "oZx6wG_typography",
});
